import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// import { CookieService } from 'ngx-cookie-service';

import { environment } from '../../environments/environment';
import { User } from '../_models/user';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(
    private http: HttpClient
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('auth-user')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    // console.log(this.currentUserSubject.value)
    return this.currentUserSubject.value;
  }

  login(account: string, password: string) {
    console.log({ account, password })
    this.logout()
    return this.http.post<any>(`${environment.API_URL}/login/web`, { account, password })
      .pipe(map(user => {
        // this.getAuth()
        // console.log(user)
        var token = user.body
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('auth-user', JSON.stringify(user));
        localStorage.setItem('auth-token', JSON.stringify(token.access_token));
        localStorage.setItem('auth-refresh-token', JSON.stringify(token.refresh_token));
        localStorage.setItem('auth-role', JSON.stringify(token.role));
        this.currentUserSubject.next(user);
        return user;
      }));
  }

  // getAuth(): any {
  //   console.log('hi')
  //   return this.http.get<any>(`${environment.LOGIN_API_URL}/policy/user`)
  //     .pipe(map(auth => {
  //       console.log(auth)
  //       // store user details and jwt token in local storage to keep user logged in between page refreshes
  //       localStorage.setItem('auth-role', JSON.stringify(auth));
  //       return auth;
  //     }));
  // }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('auth-user');
    localStorage.removeItem('auth-token');
    localStorage.removeItem('auth-refresh-token');
    localStorage.removeItem('auth-role');
    // localStorage.clear();
    this.currentUserSubject.next(null);
  }

}
